import  { useState } from "react";
import Box from "@mui/material/Box";
import { Formik } from "formik";
import Styles from "./Payment.module.scss";
import axiosClient from "../../service/axios";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";

export default function ClosePaymentDetails(props) {
 

  return (
    <>
      <Formik
        initialValues={{
          title: "",
          order_id: "",
          order_by: "",
          price: "",
        }}
        validate={(values) => {
          const errors = {};
          if (!values.price) {
            errors.payment = "Price mode is mandatory";
          }
          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          // Setting the values
          values.title = props.title;
          values.order_id = props.order_id;
          values.order_by = props.order_by;

          // Making the API call
          axiosClient
            .post(
              "https://plus.lifebank.ng/lite/v2/api/admin/failed/orders/set/carde",
              values
            )
            .then((response) => {
              props.onClickYes();
              toast.success( response.data.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            })
            .catch((error) => {
              console.error("Error:", error);
            })
            .finally(() => {
              setSubmitting(false);
            });
        }}
      >
        {({
          handleChange,
          handleSubmit,
          isSubmitting,
          values,
          event,
          resetForm,
          setFieldValue,
          handleBlur,
          errors,
          touched,
        }) => (
          <>
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, minWidth: "50ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <div>
                <Form.Control
                  as="input"
                  onChange={handleChange}
                  name="price"
                  placeholder="Enter price"
                />
                {errors.details && touched.details ? (
                  <p className="text-danger mt-1 mx-2">{errors.details}</p>
                ) : null}
              </div>

              <div className="d-flex justify-content-center mt-3">
                <button
                  type="submit"
                  className={` shadow-none  ${Styles.actionBtn} ${Styles.reject}`}
                  style={{ background: props.btnColor }}
                  onClick={handleSubmit}
                >
                  Send
                </button>
              </div>
            </Box>
          </>
        )}
      </Formik>
    </>
  );
}
